import { Box } from 'braid-design-system';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import {
  getProfileVisibilityReview,
  type ProfileVisibilityOption,
  shouldShowProfileVisibilityInline,
} from 'src/pages/Review/utils';

import { ProfileVisibilityInput } from './ProfileVisibility';

type ProfileVisibilitySectionProps = {
  profileVisibilityOptions: ProfileVisibilityOption[];
  profilePrivacyId?: string;
};

type ProfileVisibilityFormValues = {
  profilePrivacyLevel: string;
};

export const ProfileVisibilitySection = ({
  profileVisibilityOptions,
  profilePrivacyId,
}: ProfileVisibilitySectionProps) => {
  const { control, setValue, formState } =
    useFormContext<ProfileVisibilityFormValues>();

  const { profileVisibilityLevelTypename } = getProfileVisibilityReview({
    profileVisibilityOptions,
    profilePrivacyId,
  });

  const shouldShowProfileVisibilityInlineSection =
    shouldShowProfileVisibilityInline(profileVisibilityLevelTypename);

  useEffect(() => {
    if (profilePrivacyId) {
      setValue('profilePrivacyLevel', profilePrivacyId);
    }
  }, [setValue, profilePrivacyId]);

  return (
    <>
      {shouldShowProfileVisibilityInlineSection && (
        <Box data={{ testid: 'profile-privacy' }}>
          <ProfileVisibilityInput
            control={control}
            privacyLevelMessage={formState.errors.profilePrivacyLevel?.message}
          />
        </Box>
      )}
    </>
  );
};
